import CheckBox from './CheckBox.vue';
export default CheckBox;
